import { useEffect, useState } from "react";
import api from "../../lib/api";
import DashboardShell from "./DashboardShell";
import EventCard from "../../components/EventCard";
import VenueCard from "../../components/VenueCard";

export default function VisitorDashboard() {
  const [favs, setFavs] = useState({ events: [], venues: [] });
  useEffect(() => {
    api.get("/favorites").then((r) => setFavs(r.data));
  }, []);

  return (
    <DashboardShell title="Mes favoris" subtitle="Vos événements et lieux préférés">
      <h2 className="font-heading font-medium text-xl text-ink mb-4 tracking-tight">Événements ({favs.events.length})</h2>
      {favs.events.length === 0 ? (
        <p className="text-muted-foreground mb-10">Aucun favori. Ajoutez des événements à vos favoris depuis leur page.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {favs.events.map((e) => <EventCard key={e.id} event={e} />)}
        </div>
      )}
      <h2 className="font-heading font-medium text-xl text-ink mb-4 tracking-tight">Lieux ({favs.venues.length})</h2>
      {favs.venues.length === 0 ? (
        <p className="text-muted-foreground">Aucun lieu en favori.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {favs.venues.map((v) => <VenueCard key={v.id} venue={v} />)}
        </div>
      )}
    </DashboardShell>
  );
}
